import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import useMeta from "@/hooks/useMeta";
import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { CtaBand } from "@/components/site/CtaBand";
import { SessionFormat } from "@/components/site/SessionFormat";
import NotFound from "@/pages/NotFound";

const OtherServices = ({ others }) => (
  <section className="wrap pb-4">
    <div className="flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-[#B9A9D8]/50 pt-6">
      <span className="text-[#6B7280]">Also offered:</span>
      {others.map((o) => (
        <Link key={o.slug} to={`/services/${o.slug}`} className="text-link inline-flex items-center gap-1.5" data-testid={`service-detail-other-${o.slug}`}>
          {o.title} <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      ))}
    </div>
  </section>
);

export default function ServiceDetail() {
  const { slug } = useParams();
  const { content } = useContent();
  const services = content.services.offered;
  const service = services.find((s) => s.slug === slug);
  useMeta(
    service ? `${service.title} · Virtual therapy Ontario` : "Page not found",
    service
      ? `${service.title} by secure video across Ontario with Violeta Dubov, Registered Social Worker in Toronto.`
      : "This page doesn't exist. Return to Violet Psychotherapy."
  );
  if (!service) return <NotFound />;
  const others = services.filter((s) => s.slug !== slug);
  return (
    <>
      <PageHero eyebrow={content.home.services_title} title={service.title} testId="service-detail-headline">
        {service.intro || null}
      </PageHero>
      <section className="wrap pb-8">
        <ul className="grid gap-5 sm:grid-cols-2">
          {service.areas.map((a, i) => (
            <Reveal as="li" key={a.title} delay={(i % 2) * 100} className="card-soft p-7 sm:p-9" data-testid={`service-area-card-${i}`}>
              <h2 className="text-2xl leading-snug text-[#22304A] sm:text-[28px]">{a.title}</h2>
              <p className="mt-3 leading-relaxed text-[#22304A]/75">{a.description}</p>
            </Reveal>
          ))}
        </ul>
      </section>
      <section className="wrap py-12">
        <SessionFormat s={content.services} line1={service.session_format} />
      </section>
      {others.length > 0 && <OtherServices others={others} />}
      <CtaBand title={content.home.final_cta_title} button={content.home.final_cta_button} />
    </>
  );
}
